import { render } from "./RatingPage.vue?vue&type=template&id=22337dd7&scoped=true"
import script from "./RatingPage.vue?vue&type=script&lang=js"
export * from "./RatingPage.vue?vue&type=script&lang=js"

import "./RatingPage.vue?vue&type=style&index=0&id=22337dd7&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22337dd7"]])

export default __exports__